/* eslint-disable no-restricted-imports,no-duplicate-imports */
/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import axios, { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';
import {
  DUMMY_BASE_URL,
  getBaseUrl,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from 'config/apiUtils';
import { BotInfoResponse } from '../models';
import { CompanyProvisionerResponse } from '../models';
import { DeliveryResponse } from '../models';
import { GoogleMenuItemResponse } from '../models';
import { LegacyOrderResponse } from '../models';
import { MenuDetailResponse } from '../models';
import { MenuType } from '../models';
import { OrderCreateRequest } from '../models';
import { OrderPutRequest } from '../models';
import { OrderResponseNext } from '../models';
import { OrderUpdateRequest } from '../models';

export type DeleteOrderParams = {
  orderId: number;
};

export type CreateNewOrderParams = {
  orderCreateRequest: OrderCreateRequest;
};

export type CreateNewOrder_nextParams = {
  orderDate: string;
};

export type GetAllOrdersByOneDayParams = {
  localDate: string;
};

export type GetAvailableProvisionersParams = {
  telegramId: number;
};

export type GetMenuParams = {
  dayDate: string;
  companyProvisionerId?: number;
};

export type GetMenu_nextParams = {
  dayDate: string;
  companyProvisionerId?: number;
};

export type GetDeliveryInfoParams = {
  orderDate: string;
};

export type GetMyOrdersParams = {
  from: string;
  to: string;
};

export type GetMyOrders_nextParams = {
  from: string;
  to: string;
};

export type GetOrderParams = {
  telegramId: number;
  localDate: string;
};

export type GetOrder_nextParams = {
  telegramId: number;
  localDate: string;
};

export type GetMenuUnavailableTimeParams = {
  menuType?: MenuType;
};

export type IsDocumentWritableParams = {
  localDate: string;
  companyProvisionerId?: number;
};

export type PutOrderParams = {
  orderPutRequest: OrderPutRequest;
};

export type UpdateAnExistingOrderParams = {
  orderUpdateRequest: OrderUpdateRequest;
};

export type UpdateAnExistingOrder_nextParams = {
  orderDate: string;
};

export const BotControllerApi = {
  deleteOrder(request: DeleteOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'DELETE' };
    const { orderId } = request;
    const localVarUrl = '/order/{orderId}'.replace(
      `{${'orderId'}}`,
      encodeURIComponent(String(orderId)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<void>(axiosRequestArgs);
  },

  createNewOrder(request: CreateNewOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'POST' };
    const { orderCreateRequest } = request;
    const localVarUrl = '/order';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      orderCreateRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<LegacyOrderResponse>(axiosRequestArgs);
  },

  createNewOrder_next(request: CreateNewOrder_nextParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'POST' };
    const { orderDate } = request;
    const localVarUrl = '/order/{orderDate}'.replace(
      `{${'orderDate'}}`,
      encodeURIComponent(String(orderDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<OrderResponseNext>(axiosRequestArgs);
  },

  getAllOrdersByOneDay(request: GetAllOrdersByOneDayParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { localDate } = request;
    const localVarUrl = '/all/{localDate}'.replace(
      `{${'localDate'}}`,
      encodeURIComponent(String(localDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Set<OrderResponseNext>>(axiosRequestArgs);
  },

  getAvailableProvisioners(request: GetAvailableProvisionersParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { telegramId } = request;
    const localVarUrl = '/provisioners';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (telegramId !== undefined) {
      localVarQueryParameter['telegramId'] = telegramId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Array<CompanyProvisionerResponse>>(axiosRequestArgs);
  },

  getBotInfo() {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };

    const localVarUrl = '/bot/info';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<BotInfoResponse>(axiosRequestArgs);
  },

  getMenu(request: GetMenuParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { dayDate, companyProvisionerId } = request;
    const localVarUrl = '/menu/{dayDate}'.replace(
      `{${'dayDate'}}`,
      encodeURIComponent(String(dayDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (companyProvisionerId !== undefined) {
      localVarQueryParameter['companyProvisionerId'] = companyProvisionerId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Array<GoogleMenuItemResponse>>(axiosRequestArgs);
  },

  getMenu_next(request: GetMenu_nextParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { dayDate, companyProvisionerId } = request;
    const localVarUrl = '/menu/{dayDate}/next'.replace(
      `{${'dayDate'}}`,
      encodeURIComponent(String(dayDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (companyProvisionerId !== undefined) {
      localVarQueryParameter['companyProvisionerId'] = companyProvisionerId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<MenuDetailResponse>(axiosRequestArgs);
  },

  getDeliveryInfo(request: GetDeliveryInfoParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { orderDate } = request;
    const localVarUrl = '/order/delivery/{orderDate}'.replace(
      `{${'orderDate'}}`,
      encodeURIComponent(String(orderDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<DeliveryResponse>(axiosRequestArgs);
  },

  getMyOrders(request: GetMyOrdersParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { from, to } = request;
    const localVarUrl = '/orders';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (from !== undefined) {
      localVarQueryParameter['from'] =
        (from as any) instanceof Date
          ? (from as any).toISOString().substr(0, 10)
          : from;
    }
    if (to !== undefined) {
      localVarQueryParameter['to'] =
        (to as any) instanceof Date
          ? (to as any).toISOString().substr(0, 10)
          : to;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Array<LegacyOrderResponse>>(axiosRequestArgs);
  },

  getMyOrders_next(request: GetMyOrders_nextParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { from, to } = request;
    const localVarUrl = '/orders/next';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (from !== undefined) {
      localVarQueryParameter['from'] =
        (from as any) instanceof Date
          ? (from as any).toISOString().substr(0, 10)
          : from;
    }
    if (to !== undefined) {
      localVarQueryParameter['to'] =
        (to as any) instanceof Date
          ? (to as any).toISOString().substr(0, 10)
          : to;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Array<OrderResponseNext>>(axiosRequestArgs);
  },

  getOrder(request: GetOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { telegramId, localDate } = request;
    const localVarUrl = '/order/{telegramId}/{localDate}'
      .replace(`{${'telegramId'}}`, encodeURIComponent(String(telegramId)))
      .replace(`{${'localDate'}}`, encodeURIComponent(String(localDate)));
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<LegacyOrderResponse>(axiosRequestArgs);
  },

  getOrder_next(request: GetOrder_nextParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { telegramId, localDate } = request;
    const localVarUrl = '/order/{telegramId}/{localDate}/next'
      .replace(`{${'telegramId'}}`, encodeURIComponent(String(telegramId)))
      .replace(`{${'localDate'}}`, encodeURIComponent(String(localDate)));
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<OrderResponseNext>(axiosRequestArgs);
  },

  getMenuUnavailableTime(request: GetMenuUnavailableTimeParams = {}) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { menuType } = request;
    const localVarUrl = '/menu/unavailable-at';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (menuType !== undefined) {
      localVarQueryParameter['menuType'] = menuType;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<string>(axiosRequestArgs);
  },

  isDocumentWritable(request: IsDocumentWritableParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { localDate, companyProvisionerId } = request;
    const localVarUrl = '/is_writable/{localDate}'.replace(
      `{${'localDate'}}`,
      encodeURIComponent(String(localDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (companyProvisionerId !== undefined) {
      localVarQueryParameter['companyProvisionerId'] = companyProvisionerId;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<boolean>(axiosRequestArgs);
  },

  putOrder(request: PutOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'PUT' };
    const { orderPutRequest } = request;
    const localVarUrl = '/order';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      orderPutRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<OrderResponseNext>(axiosRequestArgs);
  },

  updateAnExistingOrder(request: UpdateAnExistingOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'PATCH' };
    const { orderUpdateRequest } = request;
    const localVarUrl = '/order';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      orderUpdateRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<LegacyOrderResponse>(axiosRequestArgs);
  },

  updateAnExistingOrder_next(request: UpdateAnExistingOrder_nextParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'PATCH' };
    const { orderDate } = request;
    const localVarUrl = '/order/{orderDate}'.replace(
      `{${'orderDate'}}`,
      encodeURIComponent(String(orderDate)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<OrderResponseNext>(axiosRequestArgs);
  },
};
